import React from 'react';
import { PageContent } from '~/__modules__/page';
import { UnauthorizedMessage } from '~/__modules__/error';

export default function UnauthorizedScene() {
  return (
    <PageContent empty={true}>
      <UnauthorizedMessage />
    </PageContent>
  );
}
